module.exports = __webpack_public_path__ + "media/src/images/logos/github-logo-192f7329fa00628e20806d8a358075bd.png";